import { OrderTabsNames } from "../../../../orders/models/OrderTabs.enum";
import { NavigationPath } from "./../../../../../config/routing/NavigationPath";
import i18next from "i18next";

export const generateItems = (
  state: any,
  pathname: string,
  actions: any,
  activeTab: string,
  editing: boolean
) => {
  const t = i18next.getFixedT(null, "admin");
  const { addComment } = state;
  let items: Array<any> = [];

  if(editing){
    return []
  }else if (activeTab === OrderTabsNames.COMMENTS && !addComment) {
    items = [
      {
        key: "add",
        text: t("orders.commandBar.addComment") as string,
        iconProps: { iconName: "add" },
        name: "add",
        onClick: actions.addComment,
      },
    ];
  } else if (activeTab === OrderTabsNames.DETAILS) {
    if (pathname === NavigationPath.NEW_ORDERS) {
      items = [
        {
          key: "edit",
          text: t("nav.edit") as string,
          iconProps: { iconName: "edit" },
          onClick: actions.setEditing,
        },
        {
          key: "activate",
          text: t("orders.commandBar.acceptOrder") as string,
          iconProps: { iconName: "followUser" },
          name: "activate",
          onClick: actions.setOrderAccepted,
        },
        {
          key: "delete",
          text: t("orders.commandBar.cancelOrder") as string,
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.setOrderCanceled,
        },
      ];
    } else if (pathname === NavigationPath.ACCEPTED_ORDERS) {
      items = [
        {
          key: "edit",
          text: t("nav.edit") as string,
          iconProps: { iconName: "edit" },
          onClick: actions.setEditing,
        },
        {
          key: "delete",
          text: t("orders.commandBar.cancelOrder") as string,
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.setOrderCanceled,
        },
      ];
    } else if (pathname === NavigationPath.IN_PROGRESS_ORDERS) {
      items = [
        {
          key: "edit",
          text: t("orders.commandBar.complete") as string,
          iconProps: { iconName: "edit" },
          onClick: actions.setEditing,
        },
        {
          key: "delete",
          text: t("orders.commandBar.cancelOrder") as string,
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.setOrderCanceled,
        },
        {
          key: "restore",
          text: t("orders.commandBar.restoreToAccepted") as string,
          iconProps: { iconName: "Back" },
          name: "restore",
          onClick: actions.setOrderAccepted,
        },
      ];
    }
  }

  return items;
};
